import type { SelectHTMLAttributes } from 'react'
import { ChevronDownIcon } from 'lucide-react'
import { cn } from '@/lib/utils'
import { inputVariants } from '@/components/ui/input'

/**
 * A dropdown, styled to match Input.
 *
 * A thin wrapper around a native `<select>` on @yllw/ui's input chrome, so
 * existing callers — plain `value`/`onChange`/`<option>` children — don't
 * change. The wrapper carries no width of its own: `inputVariants` puts
 * `w-full` on the `<select>` itself, so it stretches in a grid cell exactly
 * as a bare `<select>` would, and shrinks to content in a flex row.
 */
export function Select({ className, ...rest }: SelectHTMLAttributes<HTMLSelectElement>) {
  return (
    <div className="group/native-select relative" data-slot="native-select-wrapper">
      <select
        data-slot="native-select"
        className={cn(
          inputVariants(),
          'cursor-default appearance-none pr-8 hover:bg-accent disabled:hover:bg-muted',
          className,
        )}
        {...rest}
      />
      <ChevronDownIcon
        aria-hidden="true"
        className="pointer-events-none absolute top-1/2 right-2.5 size-4 -translate-y-1/2 text-muted-foreground select-none"
      />
    </div>
  )
}
